// extracted by mini-css-extract-plugin
export default {"BtnExpand":"BtnExpand_BtnExpand__0ktQ3","isExpand":"BtnExpand_isExpand__n4yJX"};